module.exports = __webpack_public_path__ + "img/trophy.ebed677a.svg";